import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CheckoutStepper from '../components/CheckoutStepper/CheckoutStepper';
import SurveyModal from '../components/SurveyModal/SurveyModal';

export default function Checkout({ cart, removeFromCart, clearCart }) {
  const [showSurvey, setShowSurvey] = useState(false);
  const navigate = useNavigate();

  // Called by stepper when order confirmed
  const handleComplete = () => {
    clearCart();
    setShowSurvey(true);
  };

  // When survey closes, go home
  const handleSurveyClose = () => {
    setShowSurvey(false);
    navigate('/');
  };

  return (
    <div className="page checkout-page">
      <h1>Checkout</h1>
      <CheckoutStepper
        cart={cart}
        removeFromCart={removeFromCart}
        clearCart={clearCart}
        onComplete={handleComplete}
      />
      {showSurvey && <SurveyModal onClose={handleSurveyClose} />}
    </div>
  );
}
